<template>
    <div class="container px-lg-5">
        <!-- Additional CSS for surveyJS -->
        <!-- Add v as the version of surveyJS packages -->
        <!-- Must update v each time upgrade surveyJS packages -->
        <link
            :href="`surveyjs/defaultV2.min.css?v=${SURVEYJS_VERSION}`"
            rel="stylesheet"
        />

        <input type="hidden" :value="webformId" name="webformId" />

        <div class="row">
            <div class="col py-3">
                <div class="card content">
                    <!-- here the top header -->
                    <div
                        class="header-footer"
                        v-if="this.isShowHeaderFooter && !this.isLoading"
                    >
                        <div class="webform-header row">
                            <div class="webform-logo col-sm my-auto text-left">
                                <img
                                    :src="businessLogo"
                                    class="h-auto"
                                    style="max-width: 175px;"
                                />
                            </div>
                            <div class="col-sm text-right my-auto">
                                <div>
                                    <strong>{{ business.label }}</strong>
                                </div>
                                <div
                                    v-html="business.business_full_address"
                                ></div>
                                <div v-if="business.phone">
                                    Phone:
                                    <PhoneNumber
                                        :phone="business.phone"
                                        :phoneCountry="
                                            business.phone_country_code
                                        "
                                    />
                                </div>
                                <div v-if="business.fax">
                                    Fax:
                                    <PhoneNumber
                                        :phone="business.fax"
                                        :phoneCountry="
                                            business.fax_country_code
                                        "
                                    />
                                </div>
                                <div>
                                    <a
                                        :href="'mailto:' + business.email"
                                        data-rel="external"
                                        >{{ business.email }}
                                    </a>
                                </div>

                                <div>
                                    <a
                                        :href="`//${business.website}`"
                                        target="_blank"
                                        >{{ business.website }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="isLoading || isSaving" class="spinner-wrapper">
                        <b-spinner variant="secondary" />
                        <span v-if="isLoading">Loading...</span>
                        <span v-else>Saving...</span>
                    </div>
                    <div
                        v-else-if="!isLoading && errorMessage === ''"
                        class="h-100"
                    >
                        <Survey
                            id="surveyjs"
                            class="h-100 surveyjs"
                            :survey="survey"
                        />
                    </div>
                    <div
                        v-else-if="!isLoading && errorMessage !== ''"
                        class="spinner-wrapper"
                    >
                        <p>{{ errorMessage }}</p>
                    </div>

                    <div class="header-footer" v-if="isShowHeaderFooter">
                        <div class="row">
                            <loader-custom
                                v-if="isLoadingFooter"
                                class="w-100"
                            />
                            <div
                                v-else
                                class="col m-auto webform-footer"
                                v-html="webformFooter"
                            ></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/*
this file is not located within the "layout.vue".
it means that anything in "helper.js" won't work here
unless we explicitly import the file.
for example: "this._message()" don't work
*/

import axios from "axios";
import AWSs3Mixin from "@/mixins/awss3";
import WebformMixin from "@/mixins/webform";
import { setLicenseKey } from "survey-core";
import { isEmpty } from "lodash";

// SEEM USING survey-vue-ui hit a issue when tested in Local and QA which, the form bacome blank after hit next and need to wait very long to render the next questions
// import { Model } from "survey-core";
// import { Survey } from "survey-vue-ui";
import { Survey, Model } from "survey-vue";

const WEBFORM_NOT_SENT = 0;
export default {
    mixins: [AWSs3Mixin, WebformMixin],
    components: {
        Survey,
        PhoneNumber: () => import("@/components/commons/phone-number"),
        LoaderCustom: () => import("@/components/elements/loader-custom.vue")
    },
    data() {
        return {
            isLoading: true,
            isLoadingFooter: true,
            isShowHeaderFooter: false,
            errorMessage: "",
            isSaving: false,
            survey: null,
            webform: null,
            webformFooter: "Powered by Daysmart Vet"
        };
    },
    computed: {
        businessLogo() {
            return (
                this._s3URL("business", this.business.id) +
                "photos/thumb_" +
                this.business.photo
            );
        },
        business() {
            return this.webform && this.webform.business;
        },
        webformEncodedId() {
            return this.$route.params.id;
        },
        webformId() {
            return this.webform && this.webform.id;
        },
        isExpired() {
            if (this.webform) {
                return this.webform.link_expired == true;
            }
            return false;
        },
        isSubmitted() {
            return this.webform && this.webform.submitted_at;
        },
        isNotSent() {
            return this.webform && this.webform.is_sent == WEBFORM_NOT_SENT;
        },
        webformS3Path() {
            return `webform/client/${this.webform.client_id}/${this.webformId}`;
        }
    },
    mounted() {
        setLicenseKey(process.env.SURVEYJS_API_KEY);
        document.getElementById("app").style.height = "100vh";
        this.fetchData();
        // remove heartbeat
        let hb = document.getElementById("the-heartbeat");
        if (hb) {
            hb.style.display = "none";
        }
    },
    methods: {
        async fetchFooter(businessId) {
            // Webform footer is from Setting > Configuration
            this.isLoadingFooter = true;
            let res = await axios({
                method: "get",
                url: `account/setting-by-business/${businessId}`,
                baseURL: process.env.BARRAMUNDI
            });
            this.isLoadingFooter = false;

            if (
                res &&
                res.data &&
                res.data.response &&
                res.data.response.resource
            ) {
                this.webformFooter =
                    res.data.response.resource.form_footer ||
                    "Powered By Daysmart Vet";
            }
        },
        async fetchData() {
            try {
                this.isLoading = true;
                this.isShowHeaderFooter = false;

                let res = await axios({
                    method: "post",
                    url: `actor/online-webform/${this.webformEncodedId}`,
                    baseURL: process.env.BARRAMUNDI,
                    params: {
                        encoded: true
                    }
                });
                let response = res.data.response;

                if (response && response.code === 200 && response.resource) {
                    this.webform = response.resource;
                    this.fetchFooter(this.webform.business_id);

                    let webformContent = this.changeSurveyToFormJSON(
                        this.webform.webform_content
                    );

                    this.survey = new Model(webformContent);
                    this.survey.showCompletedPage = false; // To prevent the completed page open upon hit submit button
                    this.applyFallbackMaxSize(this.survey);

                    this.survey.onTextMarkdown.add(this.doMarkdown);

                    if (this.isSubmitted) {
                        // Webform been submitted || not been sent
                        // then only can view only and add info alert informing the user, this form has been submitted
                        this.survey.firstPageIsStarted = false; // Disable the first page is started to viewed the page in display mode
                        this.survey.currentPageNo = 0; // to reset the first page viewed (necessary if set first page is started and timer)
                        this.survey.data = this.webform.webform_answers;
                        this.survey.mode = "display";

                        this.survey.onAfterRenderSurvey.add(
                            (survey, options) => {
                                // Adding the alert info in the survey body
                                const alertHtml = `<b-alert show variant="warning" class="alert alert-info font-weight-bold" >
                                    This form has been submitted.
                                </b-alert>`;
                                this.$nextTick(() => {
                                    const surveyBody = $("#surveyjs .sd-body");
                                    surveyBody.prepend(alertHtml);
                                });
                            }
                        );
                    } else if (this.isNotSent) {
                        // Webform not been sent : User should not able to view the form
                        throw new Error("Form unavailable.");
                    } else if (this.isExpired) {
                        // Webform is expired, the sent date has been over 2 weeks : User should not able to view the form
                        throw new Error(
                            "This form has expired, therefore can no longer receive any submission."
                        );
                    } else {
                        this.survey.onComplete.add(this.onComplete);
                        this.survey.onNavigateToUrl.add(this.onNavigateToUrl);
                    }
                    this.isShowHeaderFooter = true;
                } else {
                    // Api not retrieve the webform due to : ID not found, deleted, error on API
                    throw new Error("Form unavailable.");
                }
            } catch (e) {
                this.isShowHeaderFooter = false;
                this.errorMessage = e.message;
            } finally {
                this.isLoading = false;
            }
        },
        async onNavigateToUrl(sender, options) {
            options.allow = false;
            const sleep = m => new Promise(r => setTimeout(r, m));
            await sleep(1000);
            if (options.url) {
                window.open(
                    this.normalizeUrl(options.url),
                    "_blank",
                    "noopener,noreferrer"
                );
            }
        },
        async onComplete(sender, options) {
            // Display the "Saving..." message (can pass a string value to display a custom message)
            options.showSaveInProgress();
            let webformLink = "";
            this.isSaving = true;

            // Need to convert the base64 to S3 to be able open the pdf files from the uploaded questions
            const senderData = await this.convertBase64ToS3(sender.data, {
                jsonType: "answer"
            });

            try {
                webformLink = await this.generatePdf(
                    this.webform,
                    this.webform.webform_content,
                    senderData
                );
            } catch (error) {
                console.error(error.message);
            }

            try {
                let res = await axios.post(
                    `${process.env.BARRAMUNDI}actor/online-webform/${this.webformId}/submit`,
                    {
                        content: this.webform.webform_content,
                        answers: senderData,
                        s3_link: webformLink
                    },
                    {
                        headers: {
                            "Content-Type": "application/json"
                        }
                    }
                );
                let response = res.data.response;
                if (response && response.code == 200 && response.resource) {
                    options.showSaveSuccess(
                        "The form is submitted successfully."
                    );
                    this.survey.showCompletedPage = true;
                } else {
                    // Error might be the webform been deleted and has been answered, possible scenario the webform been open simultaneously in another device/tab/browser
                    throw new Error("Unable to submit form.");
                }
            } catch (e) {
                this.errorMessage = e.message;
                console.error(e.message);
                options.showSaveError(e.message);
            } finally {
                this.isSaving = false;
            }
        },
        changeSurveyToFormJSON(webformContent) {
            // VET-3001
            if (isEmpty(webformContent.completedHtml)) {
                webformContent.completedHtml =
                    "<h3>Thank you for completing the form</h3>";
            }

            if (isEmpty(webformContent.loadingHtml)) {
                webformContent.loadingHtml = "<h3>Loading Form...</h3>";
            }

            if (isEmpty(webformContent.completedBeforeHtml)) {
                webformContent.completedBeforeHtml =
                    "<h3>Our records show that you have already completed this form.</h3>";
            }
            return webformContent;
        }
    }
};
</script>

<style lang="scss">
@import "@/scss/spinner.scss";

body {
    background-color: #fff;
}
</style>
<style scoped>
.content {
    min-height: 100vh;
    height: 100%;
}
.header-footer {
    background-color: #fbfbfb;
    border-top-right-radius: inherit;
    border-top-left-radius: inherit;
    border-bottom: 1px solid;
    border-color: inherit;
    padding: 10px 24px;
    align-items: center;
}
@media (max-width: 576px) {
    .webform-header .webform-logo {
        text-align: center !important;
        padding: 20px 0;
    }
}
</style>
